import { Link } from '@aws-amplify/ui-react';
import { AuthEventData } from '@aws-amplify/ui';

export const SignInFooter = (props: { toForgotPassword: (data?: AuthEventData) => void; forgotPasswordText: React.ReactNode }) => {
    const { toForgotPassword, forgotPasswordText } = props;
    return (
        <div className="auth-reset-pw">
            <div className="auth-reset-pw_link">
                <Link style={{ color: 'var(--zorva-orange)' }} onClick={toForgotPassword}>
                    {forgotPasswordText}
                </Link>
            </div>
        </div>
    );
};
